import { useEffect } from "react";
import {
    Box,
    Dialog,
    IconButton,
    Slide,
    Theme,
    Toolbar,
    Typography,
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";
import { useUser } from "../../hooks/useUser";
import {useNavigate} from "react-router-dom";
import {PinnedPageType} from "../../models/modelsUserConfiguration";

export const HomeScreen = () => {

  const {userPreference, isLoading} = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if(userPreference &&
       userPreference.pinnedApplication){
         const appApiName = userPreference.pinnedApplication.ApiName_sys
         const pinnedPage = userPreference.pinnedApplication.pinnedPage

         let redirect_url = ''
         switch(pinnedPage.Type_sys){
           case "ApplicationPage":
              redirect_url = `/${appApiName}/appPage/${pinnedPage.ApiName_sys}`
              navigate(redirect_url, {replace: true})
              break;
           case "ObjectPage":
              redirect_url = `/${appApiName}/${pinnedPage.ApiName_sys}`
              navigate(redirect_url, {replace: true})
              break;
           case "CustomPage":
              redirect_url = `/${appApiName}/customPage/${pinnedPage.ApiName_sys}`
              navigate(redirect_url, {replace: true})
              break;
           default:
             return
         }



    }
  }, [userPreference])

  return (
     <Box>
        HOME SCREEN
     </Box>

);
};
